import React, { useMemo } from 'react';
import Button from 'wa-storybook/components/general/button/button';
import OpenNewPage from 'wa-storybook/components/general/icon/components/open-new-page';
import styles from './disaster-recovery.module.scss';

export const DisasterRecovery = () => {
  const eapUrl = useMemo(() => {
    const url = new URL(window.WAM.ENV.eapUrl);
    url.searchParams.append('returnUrl', window.location.href);
    return url;
  }, [window.location.href]);

  return (
    <div className={styles['eap-container']}>
      <p>{polyglot.t('login.eap.eap_card_description')}</p>
      <Button
        href={eapUrl.toString()}
        target='_blank'
        icon={OpenNewPage}
        text={polyglot.t('login.eap.eap_card_button')}
      />
    </div>
  );
};
